var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChefHatAlt11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0645 3.19173C16.3676 3.13151 16.6803 3.1 17 3.1C19.7614 3.1 22 5.45051 22 8.35C22 10.5028 20.7659 12.353 19 13.1632V16.6839C16.8549 15.6203 14.2752 15 11.5 15C9.14357 15 6.92816 15.4472 5 16.2333V13.1632C3.2341 12.353 2 10.5028 2 8.35C2 5.45051 4.23858 3.1 7 3.1C7.31972 3.1 7.63244 3.13151 7.93548 3.19173C8.84287 1.86453 10.3253 1 12 1C13.6747 1 15.1571 1.86453 16.0645 3.19173Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9644 18.3628C18.7025 20.4163 17.0274 22 15 22H8.99998C6.81248 22 5.0351 20.1562 5.00049 17.868C6.85952 17.0102 9.0849 16.5 11.5 16.5C14.3487 16.5 16.9335 17.2099 18.9644 18.3628Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChefHatAlt11);
export default __webpack_public_path__ + "static/media/chef-hat-alt-1-1.ee24261fd050769b9a1ce5e3e6959082.svg";
export { ForwardRef as ReactComponent };